import { create } from "zustand"
import { ConfirmationProps } from "@/components/ui/confirmation"

export type ConfirmationPropsWithoutOpen = Omit<ConfirmationProps, "open">

type State = {
  confirmation: ConfirmationPropsWithoutOpen | null
  isOpen: boolean
}

type Actions = {
  confirm: (props: ConfirmationPropsWithoutOpen) => Promise<boolean>
  cancel: () => void
}

const initialState: State = {
  confirmation: null,
  isOpen: false,
}

const useConfirmStore = create<State & Actions>((set) => ({
  ...initialState,

  confirm: (props) => {
    return new Promise<boolean>((resolve) => {
      set(() => {
        return {
          isOpen: true,
          confirmation: {
            onConfirm: () => {
              resolve(true)
              set(() => ({ isOpen: false }))
            },
            onCancel: () => {
              resolve(false)
              set(() => ({ isOpen: false }))
            },
            ...props,
          },
        }
      })
    })
  },

  cancel: () => {
    set(initialState)
  },
}))

export { useConfirmStore }
